(() => {
  const createGiftToken = () => {
    const bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  };

  const initializeSocialGift = (root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const button = root.querySelector('[data-social-gift-submit]');
    const error = root.querySelector('[data-social-gift-error]');
    const variantMapElement = root.querySelector('[data-social-gift-variant-map]');
    let variantMap = {};
    try {
      variantMap = JSON.parse(variantMapElement?.textContent || '{}');
    } catch (_error) {
      variantMap = {};
    }
    if (!button) return;

    button.addEventListener('click', async () => {
      const selectedVariantInput = document.querySelector(
        'form[action*="/cart/add"] input[name="id"]'
      );
      const selectedVariantId = String(
        new URL(window.location.href).searchParams.get('variant') ||
        selectedVariantInput?.value ||
        ''
      );
      const variantId = Number(
        variantMap[selectedVariantId] || root.dataset.giftVariantId
      );
      const feeVariantId = Number(root.dataset.feeVariantId || '');
      if (!variantId || !feeVariantId) return;

      const quantityInput = document.getElementById(root.dataset.quantityInputId || '');
      const quantity = Math.max(1, Number(quantityInput?.value || 1));
      const receiveUrl = String(root.dataset.giftReceiveUrl || '').trim();
      const storeDomain = String(root.dataset.storeDomain || '').trim();
      const apiVersion = String(root.dataset.storefrontApiVersion || '').trim();
      const serviceFeeYen = String(root.dataset.serviceFeeYen || '').trim();
      if (
        !receiveUrl ||
        !storeDomain ||
        !apiVersion ||
        !/^\d+$/.test(serviceFeeYen) ||
        !window.crypto?.getRandomValues
      ) {
        error.textContent = 'ソーシャルギフトの設定が完了していません。';
        error.hidden = false;
        return;
      }
      const giftToken = createGiftToken();
      const giftUrl = `${receiveUrl}${receiveUrl.includes('?') ? '&' : '?'}gift=${encodeURIComponent(giftToken)}`;
      button.disabled = true;
      error.hidden = true;

      try {
        const response = await fetch(`https://${storeDomain}/api/${apiVersion}/graphql.json`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            query: `
              mutation SocialGiftCartCreate($input: CartInput!) {
                cartCreate(input: $input) {
                  cart { checkoutUrl }
                  userErrors { field message }
                  warnings { message }
                }
              }
            `,
            variables: {
              input: {
                lines: [
                  {
                    merchandiseId: `gid://shopify/ProductVariant/${variantId}`,
                    quantity,
                    attributes: [
                      { key: '_social_gift', value: 'true' },
                      { key: '_social_gift_token', value: giftToken },
                      { key: '_social_gift_line_role', value: 'gift_item' },
                      { key: '_gift_url_expiry_days', value: root.dataset.expiryDays },
                      { key: '_gift_expiry_action', value: root.dataset.expiryAction },
                      { key: '_store_credit_expiry_days', value: root.dataset.creditExpiryDays },
                      { key: '_delivery_min_days', value: root.dataset.deliveryMinDays },
                      { key: '_delivery_max_days', value: root.dataset.deliveryMaxDays },
                      { key: '_social_gift_url', value: giftUrl },
                    ],
                  },
                  {
                    merchandiseId: `gid://shopify/ProductVariant/${feeVariantId}`,
                    quantity: 1,
                    attributes: [
                      { key: '_social_gift', value: 'true' },
                      { key: '_social_gift_token', value: giftToken },
                      { key: '_social_gift_line_role', value: 'delivery_fee' },
                      { key: '_gift_url_expiry_days', value: root.dataset.expiryDays },
                      { key: '_gift_service_fee_yen', value: serviceFeeYen },
                    ],
                  },
                ],
                attributes: [
                  { key: '_social_gift', value: 'true' },
                  { key: '_social_gift_token', value: giftToken },
                  { key: '_gift_service_fee_yen', value: serviceFeeYen },
                ],
              },
            },
          }),
        });

        if (!response.ok) throw new Error('storefront_cart_create_failed');
        const result = await response.json();
        const payload = result?.data?.cartCreate;
        const checkoutUrl = payload?.cart?.checkoutUrl;
        if (result?.errors?.length || payload?.userErrors?.length || !checkoutUrl) {
          throw new Error('storefront_cart_invalid_response');
        }

        window.SocialGiftCartGuard?.markCheckoutStarted();
        window.location.assign(checkoutUrl);
      } catch (_error) {
        error.textContent = '購入画面を開けませんでした。時間をおいてもう一度お試しください。';
        error.hidden = false;
        button.disabled = false;
      }
    });
  };

  const initializeAll = () => {
    document.querySelectorAll('[data-social-gift]').forEach(initializeSocialGift);
  };

  const restoreButtons = () => {
    document.querySelectorAll('[data-social-gift] [data-social-gift-submit]').forEach((button) => {
      button.disabled = false;
    });
  };

  document.addEventListener('DOMContentLoaded', initializeAll);
  document.addEventListener('shopify:section:load', initializeAll);
  window.addEventListener('pageshow', restoreButtons);
})();
